module.exports = __webpack_public_path__ + "img/chevron-compact-up.3f383946.svg";